<template>
  <div class="home">
    <!-- <Top /> -->
    <Header :headerData="headerData.data" />
    <!-- <Product v-if="headerData.code !== 9" :infoVoList="infoVoList" :headerData="headerData.data" /> -->
    <Tab :headerData="headerData.data" v-if="headerData.code == 0" />
    <NoData v-if="headerData.code == 9" :msg="msg" />
  </div> 
</template>

<script setup>
import { nextTick, onMounted, reactive, ref } from 'vue';
import { allTab, productData } from '@/api';
import * as tools from '@/utils/utils';
import Header from './components/Header'
import Tab from './components/Tab'
import Product from './components/Product'
import NoData from './components/NoData'
import Top from './components/Top.vue'
import {getAllTabDATA} from './data/getAllTab'

// 头部合集数据
const headerData = reactive({
  data: {},
  code: null
})
const msg = '专题已下架，看看其他内容吧'
const infoVoList = ref([]) // 带品列表
// 获取头部信息
const getAllTab = (value) => {
  headerData.data = getAllTabDATA
  headerData.code = 0
  // try {
  //   const { resultData} = await allTab({
  //     topicId: 2710513
  //   })
  //   console.log('data-----------', resultData)
  //   if (resultData.code == 0) {
  //     headerData.data = {...resultData.data}
  //     tools.setShareText(resultData.data.sceneCollName, resultData.data.summary)
  //   }
  //   headerData.code = resultData.code
  // } catch (error) {
  //   console.log(error)
  // }
}

// 获取带品信息
// const getProductData = async (value) => {
//   try {
//     const { resultData: { data } } = await productData({
//       pageSize: 10,
//       lastId: '',
//       circleId: 2710513,
//       productType: 0,
//       invokeSource: 2
//     })
//     if (data && data.infoVoList && data.infoVoList.length > 0) {
//       infoVoList.value = data.infoVoList
//     }
//     console.log(data)
//   } catch (error) {
//     console.log(error)
//   }
// }

onMounted(() => {
  // getProductData()
  getAllTab()
});
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
  opacity: 0;
}
.home {
  min-height: 100vh;
}
</style>
